import PropTypes from 'prop-types';
import './Header.css';

const Header = ({
  title = 'placeholder',
  onClose = () => {},
}) => (
  <div className="room-settings-header">
    <span className="room-settings-header-title">{`Room Settings - ${title}`}</span>
    <button className="room-settings-header-close" onClick={onClose}>
      <ion-icon name="close-outline" />
    </button>
  </div>
);

Header.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func,
};

export default Header;
